import { render, staticRenderFns } from "./PreparationPlanningBlock.vue?vue&type=template&id=31085ccc&"
import script from "./PreparationPlanningBlock.ts?vue&type=script&lang=ts&"
export * from "./PreparationPlanningBlock.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports